import React from "react";

import {
	Box,
	Slider,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";

export default function SidebarMarkSlider({
	title,
	marks,
	defaultValue,
	updateValue,
}) {
	const setValue = (event) => {
  	updateValue(event.target.value)
	}

	const valueLabelFormat = (v) => {
		const m = marks.find((m) => m.value === v)
  	return m.label ? m.label : '?';
	}

	const theme = useTheme();

	return (
		<Box sx={{
			mb: 4,
			ml: 3,
		}}>
			<Typography variant="caption">
				{title}:
			</Typography>
			<Stack
				spacing={2}
				direction="row"
				sx={{
					mb: 1,
					ml: 3,
					width: "350px",
					maxWidth: `calc(100% - ${theme.spacing(4)})`,
				}}
				alignItems="center">
				<Slider
					size="medium"
					aria-label={title}
					defaultValue={defaultValue}
					onChange={setValue}
					step={null}
					min={marks[0].value}
					max={marks[marks.length-1].value}
					valueLabelFormat={valueLabelFormat}
					getAriaValueText={valueLabelFormat}
					valueLabelDisplay="auto"
					marks={marks} />
			</Stack>
		</Box>
	)
}